module.exports = __webpack_public_path__ + "media/components/footer/static/footer_logo-a05c6d3d887d64ddde7475aae86fc33c.png";